import React, { useState } from 'react';
import { Button } from '@/shared/components/ui/Button';
import { Icon } from '@/shared/icons';
import { formatDateSafe } from '../utils/formatDateSafe';

interface PixQrCodeDisplayProps {
  qrCode: string;
  copyPaste: string;
  expiresAt?: string;
}

export const PixQrCodeDisplay: React.FC<PixQrCodeDisplayProps> = ({
  qrCode,
  copyPaste,
  expiresAt,
}) => {
  const [copySuccess, setCopySuccess] = useState(false);

  const handleCopy = async () => {
    if (copyPaste) {
      await navigator.clipboard.writeText(copyPaste);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    }
  };

  return (
    <div className="space-y-4 text-center">
      {qrCode ? (
        <div className="flex justify-center">
          <img
            src={`data:image/png;base64,${qrCode}`}
            alt="QR Code PIX"
            className="w-48 h-48 rounded-lg"
          />
        </div>
      ) : (
        <div
          className="flex items-center justify-center w-48 h-48 mx-auto rounded-lg"
          style={{ backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb' }}
        >
          <div className="text-center">
            <Icon name="alert-circle" className="h-8 w-8 mx-auto mb-2" style={{ color: '#9ca3af' }} />
            <p className="text-xs" style={{ color: '#9ca3af' }}>
              QR Code indisponivel
            </p>
          </div>
        </div>
      )}

      {copyPaste && (
        <div className="space-y-2">
          <p className="text-sm" style={{ color: '#6b7280' }}>
            Ou copie o codigo PIX:
          </p>
          <div
            className="flex items-center gap-2 p-3 rounded-lg"
            style={{ backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb' }}
          >
            <p
              className="text-xs flex-1 break-all font-mono text-left"
              style={{ color: '#374151' }}
            >
              {copyPaste}
            </p>
            <Button
              variant="secondary"
              size="sm"
              onClick={handleCopy}
            >
              <Icon
                name={copySuccess ? 'check' : 'copy'}
                className="h-4 w-4"
              />
            </Button>
          </div>
        </div>
      )}

      {expiresAt && (() => {
        const formatted = formatDateSafe(expiresAt, { dateStyle: 'short', timeStyle: 'short' }, '');
        return formatted ? (
          <p className="text-xs" style={{ color: '#9ca3af' }}>
            Expira em {formatted}
          </p>
        ) : null;
      })()}
    </div>
  );
};

PixQrCodeDisplay.displayName = 'PixQrCodeDisplay';
